import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getDoctorFullName, DoctorFullNameResponse } from '@/common/apis/services/doctor/getDoctorFullName';
import { getDoctorExpertise, DoctorExpertiseResponse } from '@/common/apis/services/doctor/getDoctorExpertise';
import { getDoctorImage, DoctorImageResponse } from '@/common/apis/services/doctor/getDoctorImage';
import { priorDoctorData } from './priorDoctorData';

export function useFactorDoctorData(slug: string) {
  const client = useQueryClient();
  const options = { enabled: !!slug, staleTime: 60_000, refetchOnWindowFocus: false };
  const fullName = useQuery(['doctorFullName', slug], () => getDoctorFullName(slug), {
    ...options, initialData: () => priorDoctorData(client, slug, 'name') as DoctorFullNameResponse | undefined,
  });
  const expertises = useQuery(['doctorExpertise', slug], () => getDoctorExpertise(slug), {
    ...options, initialData: () => priorDoctorData(client, slug, 'expertise') as DoctorExpertiseResponse[] | undefined,
  });
  const image = useQuery(['doctorImage', slug], () => getDoctorImage(slug), {
    ...options, initialData: () => priorDoctorData(client, slug, 'image') as DoctorImageResponse | undefined,
  });
  return { fullName, expertises, image };
}